import { Flex, Text } from "@chakra-ui/react";
import Cleave from "cleave.js/react";

export default function ReusableAmountInput({
  onChange,
  placeholder,
  label,
  onBlur,
  type = true,
  value,
  readOnly = false,
}) {
  return (
    <Flex w="100%" align="start" direction="column" gap={label ? "8px" : ""}>
      <Text color="var(--container_color)" className="">
        {label}
      </Text>
      <Flex
        align="center"
        border="1px solid #ccc"
        borderRightRadius={type ? "" : "0.5rem"}
        w="100%"
        borderRadius={type ? "8px" : ""}
        justify="center"
        padding={type ? "0.5rem" : "0.45rem"}
      >
        <Cleave
          placeholder={placeholder}
          options={{
            numeral: true,
            numeralThousandsGroupStyle: "thousand",
          }}
          style={{
            border: "none",
            outline: "none",
            width: "100%",
            background: "#fff",
            color: "#000",
          }}
          onChange={(e) => onChange(e)}
          readOnly={readOnly}
          onKeyUp={!type ? onBlur : () => {}}
          value={value}
        />
      </Flex>
    </Flex>
  );
}
